import Image from "next/image";
import Link from "next/link";
import React, { useState } from "react";
import Logo from "../../../../public/logo.svg";
import AddressInfo from "./AddressInfo";
import MenuItems from "../MenuItem";
import { BiGlobe, BiSearch } from "react-icons/bi";
import { MdOutlineClose } from "react-icons/md";
import SearchBox from "./Search";
import CountryList from "./CountryList";
import { IProductsByCountryCategory } from "@/lib/interface";
import { Button } from "@mui/base";
import GetQuote from "@/app/GetQuote";

const DesktopHeader = ({
  categoryData,
  isLoading,
}: {
  isLoading: boolean;
  categoryData: IProductsByCountryCategory | null;
}) => {
  const [search, setSearch] = useState(false);
  const [country, setCountry] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const Icon = search ? MdOutlineClose : BiSearch;

  // console.log('categoryData',categoryData)
  return (
    <div className="hidden xl:block sticky top-0 z-40 w-full bg-white shadow-md backdrop-blur-md">
      <AddressInfo />

      <div className="container relative py-2">
        <div className="flex">
          <Link href="/">
            <Image
              src={Logo}
              alt="Presto Instruments"
              fetchPriority="high"
              loading="lazy"
            />
          </Link>

          <div className="flex-1 flex items-center justify-end relative">
            <ul className="flex gap-6 items-center">
              {MenuItems.map((m) => {
                if (m?.children) {
                  return (
                    <li className="group transition" key={m.id}>
                      <Link
                        href={m.href ?? "/error"}
                        className="text-sm lg:text-base text-secondary-dark font-semibold hover:text-primary-main transition"
                      >
                        {m.name}
                      </Link>
                      {m.products ? (
                        <div className="bg-white md:w-[1200px] p-8 xl:-left-12 absolute rounded-md shadow-xl border border-t-0 group-hover:block hidden">
                          <div className="grid grid-cols-2 gap-5">
                            {isLoading
                              ? [1, 2, 3, 4].map((i) => (
                                  <div
                                    key={i}
                                    className="flex flex-col pr-10 pl-2"
                                  >
                                    <h4 className="w-full h-8 mb-2 loading"></h4>
                                    <ul className="flex flex-col gap-1">
                                      {[1, 2, 3, 4].map((p) => (
                                        <li
                                          key={p}
                                          className="text-secondary-dark rounded-md group hover:shadow-md p-[0.5px] flex gap-2 loading"
                                        >
                                          <div className="loading w-5 h-5 font-semibold text-sm"></div>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                ))
                              : categoryData?.Categories?.map((c) => (
                                  <Link
                                    key={c.CategoryID}
                                    href={`/category/${
                                      c?.CategoryDetails?.Slug || c?.Slug
                                    }${
                                      categoryData?.CountrySlug &&
                                      categoryData?.CountrySlug !== "india"
                                        ? "/" + categoryData?.CountrySlug
                                        : ""
                                    }`}
                                    className="flex flex-col pr-10"
                                  >
                                    <h4 className="text-secondary-dark uppercase text-base mt-8 mb-3 pb-1 font-bold border-b-2 border-primary-main">
                                      {c?.CategoryDetails?.CategoryName ||
                                        c?.CategoryName}
                                      {categoryData?.CountryName
                                        ? ` - ${categoryData?.CountryName}`
                                        : ""}
                                    </h4>

                                    <ul className="flex flex-col pl-2 gap-1">
                                      {c?.Products?.slice(0, 4).map((p) => (
                                        <li
                                          key={p.ProductID}
                                          className="text-secondary-dark rounded-md group hover:shadow-md p-2 flex gap-2"
                                        >
                                          <Link
                                            href={`/products/${p.Slug}${
                                              categoryData?.CountrySlug &&
                                              categoryData?.CountrySlug !==
                                                "india"
                                                ? "/" +
                                                  categoryData?.CountrySlug
                                                : ""
                                            }`}
                                            className="font-semibold hover:text-orange-600 text-sm"
                                          >
                                            {p.Title}
                                          </Link>
                                        </li>
                                      ))}
                                    </ul>
                                  </Link>
                                ))}
                          </div>
                        </div>
                      ) : (
                        <div className="bg-white md:w-[31%] rounded-md shadow absolute p-2 hidden group-hover:block">
                          <ul>
                            {m?.children?.map((c) => (
                              <li
                                key={c.id}
                                className="p-2 text-secondary-dark rounded-md hover:bg-primary-light border-b border-dashed"
                              >
                                <Link
                                  href={c.href ?? "/error"}
                                  className="block p-1 text-sm hover:text-white"
                                >
                                  {c.name}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </li>
                  );
                }

                return (
                  <li key={m.id}>
                    <Link
                      href={m.href ?? "/error"}
                      className="text-sm lg:text-base text-secondary-dark font-semibold hover:text-primary-main transition"
                    >
                      {m.name}
                    </Link>
                  </li>
                );
              })}
              <li className="flex items-center">
                <Icon
                  className="text-2xl cursor-pointer"
                  onClick={() => setSearch(!search)}
                />
                {search && <SearchBox close={() => setSearch(false)} />}
              </li>
              <li className="flex items-center group">
                <BiGlobe
                  className="text-2xl text-orange-600 cursor-pointer"
                  onMouseEnter={() => setCountry(true)}
                />
                {country && <CountryList close={() => setCountry(false)} />}
              </li>
              <button
                type="submit"
                onClick={() => setIsModalOpen(true)}
                className="group overflow-y-hidden py-1  px-4 border  font-semibold rounded-full flex items-center relative  before:absolute before:bottom-0 before:left-0 before:bg-orange-main before:translate-y-0 hover:before:translate-y-12 before:transition-all before:w-full before:h-full before:rounded-full"
              >
                <p className="relative flex items-center group-hover:text-orange-main text-white">
                  Get a Quote
                </p>
              </button>

              {isModalOpen && (
                <div
                  className="fixed top-40 ml-[680px] flex items-center justify-center bg-primary-main rounded-lg"
                  onClick={() => setIsModalOpen(false)}
                >
                  <div
                    className="bg-modalFormColor p-6 rounded shadow-lg w-86 relative transition-transform ease-in duration-300 transform scale-100"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <button
                      onClick={() => setIsModalOpen(false)}
                      className="absolute top-6 text-2xl right-5 text-white"
                    >
                      &times;
                    </button>
                    <GetQuote setIsModalOpen={setIsModalOpen} />
                  </div>
                </div>
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesktopHeader;
